<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 15px;">
      {{ $t('ref_link') }}: <el-button type="text" @click="doCopy"><i class="material-icons">content_copy</i> {{ref_link}}</el-button>
    </el-card>

    <el-tabs v-model="tab">
      <el-tab-pane :label="$t('statistics')" name="statistics">
        <div class="filter-form">
          <el-row :gutter="20">
            <el-col :span="6">
              <label class="label">
                {{ $t('date') }}
              </label>
              <el-date-picker
                  v-model="pickerModel"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="-"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :picker-options="pickerOptions" style="width: 100%">
              </el-date-picker>
            </el-col>


            <el-col :span="6">
              <el-button type="primary" @click="getStat()" icon="el-icon-refresh">{{ $t('refresh') }}</el-button>
            </el-col>
          </el-row>
        </div>

        <el-card shadow="never" v-loading="loading" v-if="!data.report.length">
          <div style="text-align: center; color: #8F9298">{{ $t('el.table.emptyText') }}</div>
        </el-card>

        <div class="el-table el-table--enable-row-hover el-table--enable-row-transition " v-loading="loading" v-if="data.report.length">
          <div class="el-table__body-wrapper is-scrolling-none">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
              <thead class="has-gutter">
              <tr>
                <th rowspan="2" class="is-leaf is-sortable">
                  <div class="cell">
                    {{ $t('period') }}
                  </div>
                </th>
                <th class="is-leaf is-sortable">
                  <div class="cell">
                    {{ $t('referral')}}
                  </div>
                </th>

                <th class="is-leaf is-sortable">
                  <div class="cell">
                    {{ $t('income') }}, $
                  </div>
                </th>
                <th class="is-leaf is-sortable">
                  <div class="cell">
                    {{ $t('income') }}, ₽
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr class="el-table__row" v-for="(item, index) in data.report" :key="index">
                <td>
                  <div class="cell">{{item.period}}</div>
                </td>
                <td>
                  <div class="cell">{{item.referral.name}}</div>
                </td>
                <td>
                  <div class="cell">{{ item.payouts | n(4, '$') }}</div>
                </td>
                <td>
                  <div class="cell">{{ item.rub_payouts | n(2, '₽') }}</div>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td>
                  <div class="cell">{{ $t('total') }}</div>
                </td>
                <td>
                  <div class="cell">-</div>
                </td>
                <td>
                  <div class="cell">{{ data.totalColumn.payouts | n(4, '$') }}</div>
                </td>
                <td>
                  <div class="cell">{{ data.totalColumn.rub_payouts | n(2, '₽') }}</div>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </el-tab-pane>
      <el-tab-pane :label="$t('referrals')" name="referrals">

        <ReferralList />

      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import PickerOptions from '../mixins/PickerOptions'
import qs from 'qs'
import ReferralList from "../components/ReferralList";
export default {
  name: "Referral",
  components: {ReferralList},
  mixins: [
    PickerOptions
  ],
  data () {
    return {
      tab: 'statistics',
      ref_id: this.$store.getters.getUser.hid,
      model: {
        fromDate: null,
        untilDate: null
      },
      data: {
        report: [],
        totalColumn: {},
        meta: {},
        info: {}
      },
      order: 'period',
      orderDirection: 'desc',
      loading: false
    }
  },
  watch: {
    model: {
      handler () {
        this.getStat();
      },
      deep: true
    },
    '$store.getters.getUser': {
      handler () {
        this.ref_id = this.$store.getters.getUser.hid;
      },
      deep: true
    }
  },
  computed: {
    ref_link() {
      return location.protocol+'//'+location.hostname+'/register?ref='+this.ref_id;
    }
  },
  created () {

  },
  methods: {
    getStat () {
      this.next = 0;
      this.loading = true;
      this.$axios.get('/stat/referrals?' + qs.stringify({ sort: (this.orderDirection === 'desc' ? '-' : '') + this.order, c: this.model }, { encode: false })).then((res) => {
        this.data = res.data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    doCopy: function () {
      const vm = this;
      this.$copyText(this.ref_link).then(function () {
        vm.$message.success(vm.$t('notice.link_copied'));
      })
    }
  }
}
</script>

<style scoped>

</style>